import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import DocumentHead from 'legacyComponents/documentHead';
import { MainWrapper } from 'legacyComponents/styled/lib';
import OrderList from 'apps/order/orderList';
import { PlanMonitor } from 'apps/initiative/views/PlanMonitor';

import { useNoAuthRedirect, useClientStore } from '../../hooks';

const OrdersPage = observer(() => {
  const clientStore = useClientStore();
  useNoAuthRedirect();

  const { activeSpace } = clientStore;
  const title =
    activeSpace?.spaceType === 'INITIATIVE'
      ? `${activeSpace?.content?.title}'s Orders`
      : 'My Orders';

  return (
    <PlanMonitor>
      <DocumentHead title={title} />
      <MainWrapper>
        <OrderList />
      </MainWrapper>
    </PlanMonitor>
  );
});
OrdersPage.propTypes = {
  routerStore: PropTypes.object,
};

export default OrdersPage;
